export default __webpack_public_path__ + "static/media/greenBayPackersVideo-2x.f6bba41b.jpg";